<template>
  <div>
    <a-modal
      v-show="!ishand"
      id="warp_sim12"
      width="40rem"
      v-model="visible"
      on-ok="handleOk1"
      v-dragModal
      @cancel="handleCancel(0)"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
      :dialog-style="{top: 22 +'%'}"
    >
      <div class="mark-file">
        <div
          style="
            background-color: #0c8b97;
            border-radius: 10px 10px 0 0;
            color: #fff;
            width: 38rem;
            margin: 1rem 1rem 0 1rem;
            text-align: center;
          "
        >
        導出數據
        </div>
      </div>
      <div solt="title" style="position: relative">
      </div>
      <div class="content">
        <div style="margin-top: 2rem;">
          <div style="color: #0c8b97;">請選擇數據參數</div>
          <div style="display: flex;align-items: center;margin-top: 1.5rem;">
            <div class="upFlex">
              <div style="flex-shrink: 0;">下載格式：</div>
              <a-select v-model="form.xzgs" placeholder="請選擇下載格式" style="width: 100%;">
                <a-select-option value="PDF">PDF</a-select-option>
                <a-select-option value="Excel">Excel</a-select-option>
              </a-select>
            </div>
            <div style="width: 10%;"></div>
            <div class="upFlex">
              <div style="flex-shrink: 0;">排序方式：</div>
              <a-select v-model="form.pxfs" placeholder="操作人員、操作時間" style="width: 100%;">
                <a-select-option value="0">操作人員</a-select-option>
                <a-select-option value="1">操作時間</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div style="margin:2.5rem 0 2rem">
          <div @click="saveClick()" class="saveBtn">導&emsp;出</div>
        </div>
      </div>
      <div style="width: 100%; height: 1px"></div>

    </a-modal>
  </div>
</template>

<script>
import App from "@/assets/app.js";
export default {

  data() {
    return {
      ishand: false,
      visible: true,
      userfileAuditAdmin: this.$store.state.rolesdata.indexOf("userfileAuditAdmin") >= 0,
      form:{
        xzgs:'PDF',
        pxfs:undefined
      },
     
    };
  },
  mounted() {
    // this.queryData();
  },

  methods: {
    handleCancel(ev) {
        this.$emit("child", 0);
    },

    saveClick(){
      this.$emit("child", this.form);
      // this.$ajax({
      //   method: 'post',
      //   url: this.$api.editMoneytoHKDRate,
      //   headers: {
      //     token: this.$store.state.token
      //   },
      //   data: {
      //     HKDRate: {
      //       AUD: this.aud,
      //       TWD: this.twd,
      //       SGD: this.sgd,
      //       JPY: this.jpy,
      //       USD: this.usd,
      //       CNY: this.cny
      //     }
      //   }
      // }).then(res => {
      //   if (res.data.qmiscode === 1000) {
      //     App.oTool.successT("操作成功");
      //     this.$emit("child", 0);
      //   } else {
      //     App.oTool.warningT(res.data.qmismsg);
      //   }
      // })
    }
    

  },
};
</script>

<style lang="scss">
	@media screen and (min-width:2200px){
    .saveBtn{
      font-size: 20px !important;
    }
    .mark-file div{
      font-size: 0.8rem !important;
    }
    .content{
      font-size: 20px !important;
    }
    .upFlex .ant-select-selection__rendered{
      line-height: 1.75rem !important;
    }

  }
.saveBtn{
  width: 20%;
  background: #0c8b97;
  padding: 8px 0;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  font-size: 16px;
  margin: auto;
  cursor: pointer;
}
.btnOn{
  margin-right: 15%;
  background: #ed4849;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  padding: 10px 50px;
  cursor: pointer;
}
.btnOK{
  background: #0c8b97;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  padding: 10px 50px;
  cursor: pointer;
}
.myStyle{
  border-bottom: none !important;
}
.show-more{
  text-align: center;
}
.score-img {
  width: 16px;
  transition: all 0.3s;
}
.rotate-img {
  transform: rotate(180deg);
}
.content-top1{
  width: 100%;
  height: 60px;
  background:#ffffff; 
  color: #000000;
  line-height: 60px;
  display: flex;
  padding: 0 20px;

}
.phoneSty .ant-select-arrow {
  right: 6px !important;
}
.phoneSty .ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 35%;
}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix {
  left: 2px !important;
  top: 18px;

}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix :not(.anticon),
.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
  line-height: 25.5px !important;
}
.phoneSty .ant-select-selection {
  border: 0 !important;
  height: 25px;
}
.phoneSty .ant-select-focused .ant-select-selection,
.ant-select-selection:active,
.ant-select-selection:focus {
  border: 0 !important;
  box-shadow: none !important;
}


.address .ant-form-item-label {
  width: 15% !important;
}
.address .ant-form-item-control-wrapper {
  width: 85% !important;
}
.content {
  padding-bottom: 1rem;
  border-radius: 0 0 10px 10px;
  padding: 1rem;
  background-color: #fff;
  width: 38rem;
  margin: 0 auto;
  margin-bottom: 1rem;
  min-height: 50px;
  font-size: 16px;
}
#warp_sim12 .ant-modal-header,
#warp_sim12 .ant-modal-body {
  background-color: #e5e5e5 !important;
  padding: 1rem;
  padding-top: 0.7rem;
}

.mark-file {
  position: absolute;
  top: 0;
  left: 0;

  div {
    width: 6rem;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    display: inline-block;
  }
}

#warp_sim12 {
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
  }
  .ant-form-explain {
    display: none;
  }

  .ant-modal {
    top: 8%;
  }

  .ant-col-12 {
    text-align: right;
  }
  .myleft {
    text-align: left;
  }
  .ant-form-item-label {
    width: 30%;
  }

  .ant-form-item,
  .ant-form-item-control {
    width: 100%;

    .ant-calendar-picker {
      width: 100%;
    }
  }

  .ant-radio-group-default {
    width: 100%;
    margin-top: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 0.8rem;
    }
  }

  .ant-form-item-control-wrapper {
    width: 70%;

    .ant-form-item-control {
      width: 100%;
    }
  }

  #lastname {
    text-align: right;

    .ant-form-item-label {
      width: 10%;
    }

    .ant-form-item-control-wrapper {
      width: 86%;
    }
  }

  .ant-form-inline .ant-form-item {
    margin-right: 0;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-form-item {
    margin-bottom: 1rem;
  }

  .ant-form-item label {
    font-size: 0.8rem !important;
  }

  .ant-input {
    font-size: 0.8rem !important;
  }

  .ant-select-selection-selected-value {
    font-size: 0.8rem !important;
  }

  .ant-form-item-children {
    font-size: 0.8rem !important;
  }

  .ant-modal-body {
    padding: 0;
    padding-top: 2.5rem;
  }

  .btn1 {
    cursor: pointer;
    width: 8rem;
    height: 2rem;
    font-size: 0.8rem;
    color: #fff;
    border: 0;
    border-radius: 5px;
    margin: 0 3rem;
  }

  .btnx {
    background-color: #0c8b97;
  }

  .btn2 {
    background-color: #ed4849;
  }

  .mydivs {
    max-height: 7rem;
    overflow-y: auto;
    // margin-bottom: 1rem;
    padding: 1rem;
    margin-left: 4%;
    width: 96%;
    background-color: #f5f5f5;
    margin-bottom: 1rem;

    .c {
      font-size: 0.8rem;
    }

    .f {
      // text-align: right;
      display: flex;
      justify-content: space-between;
    }

    .t {
      margin: 0.5rem 0;
      border-bottom: 1px solid #d9d9d9;
    }
  }
  .denglu .ant-select{
    width: 9rem;
  }
}
</style>
<style lang="scss" scoped>
.upFlex{
  display: flex;
  align-items: center;
  width: 100%;
}

</style>
